import { __awaiter, __generator } from "tslib";
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { fetchWorkloadPublicDataConfig } from '@office-start/workload-publicdata-config-service';
import { create } from 'zustand';
export var FloodgateStore = create(function (set, get) { return ({
    disabled: false,
    initialized: false,
    feedback: undefined,
    initFloodgate: function (initData, logInitSuccess, logInitFailure) { return __awaiter(void 0, void 0, void 0, function () {
        var initialized, workloadPublicDataConfig, identityResult, identity, _a, userConsentInfo, hasConsent, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    initialized = get().initialized;
                    if (initialized) {
                        return [2 /*return*/];
                    }
                    set({ initialized: true });
                    if (initData.campaigns.length === 0) {
                        set({ disabled: true });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetchWorkloadPublicDataConfig()];
                case 2:
                    workloadPublicDataConfig = _b.sent();
                    identityResult = getOfficeIdentity();
                    if (!identityResult) return [3 /*break*/, 3];
                    _a = identityResult;
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, fetchIdentity()];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    identity = _a;
                    userConsentInfo = workloadPublicDataConfig === null || workloadPublicDataConfig === void 0 ? void 0 : workloadPublicDataConfig.userConsentInfo;
                    hasConsent = (userConsentInfo === null || userConsentInfo === void 0 ? void 0 : userConsentInfo.UserConsent) ===
                        0 /* ConsumerUserConsentGroup.CanConsent */;
                    if (!hasConsent && identity.isMsa) {
                        logInitFailure === null || logInitFailure === void 0 ? void 0 : logInitFailure();
                        set({ disabled: true });
                        return [2 /*return*/];
                    }
                    scheduleWork(function () {
                        import('../loadAndInitializeHarmonyFloodgate')
                            .then(function (module) {
                            return module.loadAndInitializeHarmonyFloodgate(initData);
                        })
                            .then(function (feedback) {
                            logInitSuccess === null || logInitSuccess === void 0 ? void 0 : logInitSuccess();
                            set({ feedback: feedback });
                        })
                            .catch(function () {
                            logInitFailure === null || logInitFailure === void 0 ? void 0 : logInitFailure();
                            set({ disabled: true });
                        });
                    }, IDLE_VERYLOW_PRIORITY);
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _b.sent();
                    // Handle errors from fetchWorkloadPublicDataConfig or fetchIdentity
                    logInitFailure === null || logInitFailure === void 0 ? void 0 : logInitFailure();
                    set({ disabled: true });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); },
    disableFloodgate: function () {
        set({ disabled: true });
    },
}); });
export var useFloodgate = function () {
    return FloodgateStore(function (state) { return state.feedback; });
};
export var useInitFloodgate = function () {
    return FloodgateStore(function (state) { return state.initFloodgate; });
};
export var useFloodgateDisabled = function () {
    return FloodgateStore(function (state) { return state.disabled; });
};
//# sourceMappingURL=FloodgateStore.js.map